import { shape, string, number, arrayOf } from 'prop-types';
import pick from 'lodash/pick';
import { CandidateOpportunitiesConst } from '@axiom/const';
import moment from 'moment';

import { getOpportunitiesByTalentId } from '../api/talent-opportunities-api';
import { getTalent } from '../api/legacy-talent-api';
import GenericStore from '../classes/generic-store';

const { CandidateStatuses } = CandidateOpportunitiesConst;

class CandidateAvailabilityModalStoreClass extends GenericStore {
  openModal = candidateId =>
    this.setState(
      Promise.all([
        getTalent(candidateId),
        getOpportunitiesByTalentId(candidateId),
      ]).then(([{ data: candidate }, { data: candidacyOpportunities }]) => ({
        ...pick(candidate, [
          'calculatedDisplayName',
          'weeklyAvailability',
          'currentAvailabilityUpdatedAt',
          'calculatedDesiredWeeklyHours',
          'desiredHoursUpdatedAt',
          'soonestEngagementEndDate',
          'soonestEngagementEndDateStatus',
          'calculatedEngagedAndReservedHours',
          'availabilityPreferencesUpdatedAt',
        ]),
        activeEngagements: candidacyOpportunities
          .filter(opp => opp.candidateStatus === CandidateStatuses.Engaged)
          .sort((a, b) => {
            if (!moment(a.position.endDate).isSame(b.position.endDate)) {
              return moment(a.position.endDate).isBefore(b.position.endDate)
                ? -1
                : 1;
            }
            return a.accountName.localeCompare(b.accountName);
          }),
      }))
    );

  closeModal = () => this.clearState();

  getDataShape = () =>
    shape({
      calculatedDisplayName: string,
      weeklyAvailability: number,
      currentAvailabilityUpdatedAt: string,
      calculatedDesiredWeeklyHours: number,
      desiredHoursUpdatedAt: string,
      soonestEngagementEndDate: string,
      soonestEngagementEndDateStatus: string,
      activeEngagements: arrayOf(shape({})),
      calculatedEngagedAndReservedHours: shape({
        totalEngagedHours: number,
        totalReservedHours: number,
      }),
    });
}

export const CandidateAvailabilityModalStore =
  new CandidateAvailabilityModalStoreClass();
